// StatisticPage.jsx
import React, { useState } from "react";
import {
  EuiPage,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiEmptyPrompt,
  EuiTitle,
} from "@elastic/eui";
import { useParams } from "react-router-dom";
import StatisticChart from "../components/StatisticChart";
import ChatPanel from "../components/ChatPanel";
import SessionListAll from "../components/SessionListAll";
import AgentList from "../components/AgentList";

const StatisticPage = () => {
  const { courseNumber, courseName } = useParams();
  const [agentName, setAgentName] = useState(null);
  const [agentConfig, setAgentConfig] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [chatHistory, setChatHistory] = useState([]);
  const [allData, setAllData] = useState([]);

  if (!courseNumber) {
    return null;
  }

  const course = { course_name: courseName, course_number: courseNumber };

  return (
    <EuiPage restrictWidth="80%" style={{ overflowY: "hidden" }}>
      <EuiFlexGroup direction="column" style={{ maxWidth: "100%" }}>
        {/* Statistic chart */}
        <EuiFlexItem>
          <StatisticChart data={allData} />
        </EuiFlexItem>

        {/* Main content area */}
        <EuiFlexItem>
          <div style={{ maxHeight: "60vh" }}>
            <EuiFlexGroup gutterSize="none">
              {/* Left Side: Agents & Sessions */}
              <EuiFlexItem grow={1}>
                {/* Title centered */}
                <EuiFlexGroup justifyContent="center" alignItems="center">
                  <EuiFlexItem grow={false}>
                    <EuiTitle>
                      <h3>{courseNumber + " " + courseName}</h3>
                    </EuiTitle>
                  </EuiFlexItem>
                </EuiFlexGroup>

                <EuiFlexGroup direction="column">
                  <EuiFlexItem>
                    <AgentList
                      course={course}
                      showCreate={false}
                      showAll={true}
                      buttonText="All Agents"
                      onSelect={(agent) => {
                        if (!agent) return;
                        setAgentName(agent.config_name);
                        setAgentConfig(agent);
                      }}
                    />
                  </EuiFlexItem>

                  <EuiFlexItem>
                    <SessionListAll
                      course={course}
                      agent={agentConfig}
                      selectedSession={selectedSession}
                      setSelectedSession={setSelectedSession}
                      setChatHistory={setChatHistory}
                      setAllData={setAllData}
                    />
                  </EuiFlexItem>
                </EuiFlexGroup>
              </EuiFlexItem>

              {/* Right Side: ChatPanel or "Please select session" */}
              <EuiFlexItem grow={3}>
                {selectedSession ? (
                  <ChatPanel
                    data={chatHistory}
                    agentName={selectedSession.config_name}
                    userName={selectedSession.session_owner}
                  />
                ) : (
                  <EuiPanel
                    style={{
                      height: "70vh",
                      overflow: "auto",
                      maxWidth: "100%",
                    }}
                  >
                    <EuiEmptyPrompt
                      iconType="securityAnalyticsApp"
                      iconColor="default"
                      title={<h2>Please Select a Session First</h2>}
                      titleSize="xs"
                      body={
                        <p>You must select a session to chat with an agent.</p>
                      }
                    />
                  </EuiPanel>
                )}
              </EuiFlexItem>
            </EuiFlexGroup>
          </div>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPage>
  );
};

export default StatisticPage;
